export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13557.ce91430e.jpg";